import Head from "next/head";
import React, { useState } from "react";
import { Breadcrumb, BreadcrumbItem } from "react-bootstrap";
import Faqs from "../src/components/design-pages/faq";

const areaConversionFactors = {
  "Square Meter": {
    "Square Feet": 10.7639, // 1 square meter = 10.7639 square feet
    Hectare: 0.0001, // 1 square meter = 0.0001 hectares
    "Square Yard": 1.19599, // 1 square meter = 1.19599 square yards
    Acre: 0.000247105, // 1 square meter = 0.000247105 acres
    Bigha: 0.00003025, // 1 square meter = 0.00003025 bighas
    Ground: 0.00008361, // 1 square meter = 0.00008361 grounds
    Cent: 0.0247105, // 1 square meter = 0.0247105 cents
    Guntha: 0.0247105, // 1 square meter = 0.0247105 gunthas
  },
  "Square Feet": {
    "Square Meter": 0.092903, // 1 square foot = 0.092903 square meters
    Hectare: 0.0000092903, // 1 square foot = 0.0000092903 hectares
    "Square Yard": 0.111111, // 1 square foot = 0.111111 square yards
    Acre: 0.0000229568, // 1 square foot = 0.0000229568 acres
    Bigha: 0.0000028191, // 1 square foot = 0.0000028191 bighas
    Ground: 0.000007782, // 1 square foot = 0.000007782 grounds
    Cent: 0.00229568, // 1 square foot = 0.00229568 cents
    Guntha: 0.00229568, // 1 square foot = 0.00229568 gunthas
  },
  Hectare: {
    "Square Meter": 10000, // 1 hectare = 10000 square meters
    "Square Feet": 107639, // 1 hectare = 107639 square feet
    "Square Yard": 11959.9, // 1 hectare = 11959.9 square yards
    Acre: 2.47105, // 1 hectare = 2.47105 acres
    Bigha: 0.3025, // 1 hectare = 0.3025 bighas
    Ground: 0.836127, // 1 hectare = 0.836127 grounds
    Cent: 24.7105, // 1 hectare = 24.7105 cents
    Guntha: 24.7105, // 1 hectare = 24.7105 gunthas
  },
  "Square Yard": {
    "Square Meter": 0.836127, // 1 square yard = 0.836127 square meters
    "Square Feet": 9, // 1 square yard = 9 square feet
    Hectare: 0.0000836127, // 1 square yard = 0.0000836127 hectares
    Acre: 0.000206612, // 1 square yard = 0.000206612 acres
    Bigha: 0.0000252929, // 1 square yard = 0.0000252929 bighas
    Ground: 0.0000694444, // 1 square yard = 0.0000694444 grounds
    Cent: 0.0206612, // 1 square yard = 0.0206612 cents
    Guntha: 0.0206612, // 1 square yard = 0.0206612 gunthas
  },
  Acre: {
    "Square Meter": 4046.86, // 1 acre = 4046.86 square meters
    "Square Feet": 43560, // 1 acre = 43560 square feet
    Hectare: 0.404686, // 1 acre = 0.404686 hectares
    "Square Yard": 4840, // 1 acre = 4840 square yards
    Bigha: 0.0625, // 1 acre = 0.0625 bighas
    Ground: 0.17284, // 1 acre = 0.17284 grounds
    Cent: 40.4686, // 1 acre = 40.4686 cents
    Guntha: 40.4686, // 1 acre = 40.4686 gunthas
  },
  Bigha: {
    "Square Meter": 3025.29, // 1 bigha = 3025.29 square meters
    "Square Feet": 32670.7, // 1 bigha = 32670.7 square feet
    Hectare: 0.03025, // 1 bigha = 0.03025 hectares
    "Square Yard": 3600, // 1 bigha = 3600 square yards
    Acre: 0.0125, // 1 bigha = 0.0125 acres
    Ground: 0.0277778, // 1 bigha = 0.0277778 grounds
    Cent: 8.27695, // 1 bigha = 8.27695 cents
    Guntha: 8.27695, // 1 bigha = 8.27695 gunthas
  },
  Ground: {
    "Square Meter": 2400, // 1 ground = 2400 square meters
    "Square Feet": 25833.3, // 1 ground = 25833.3 square feet
    Hectare: 0.024711, // 1 ground = 0.024711 hectares
    "Square Yard": 2880, // 1 ground = 2880 square yards
    Acre: 0.0119795, // 1 ground = 0.0119795 acres
    Bigha: 0.036, // 1 ground = 0.036 bighas
    Cent: 9.68, // 1 ground = 9.68 cents
    Guntha: 9.68, // 1 ground = 9.68 gunthas
  },
  Cent: {
    "Square Meter": 40.4686, // 1 cent = 40.4686 square meters
    "Square Feet": 435.6, // 1 cent = 435.6 square feet
    Hectare: 0.000404686, // 1 cent = 0.000404686 hectares
    "Square Yard": 48.4, // 1 cent = 48.4 square yards
    Acre: 0.0001, // 1 cent = 0.0001 acres
    Bigha: 0.00003125, // 1 cent = 0.00003125 bighas
    Ground: 0.0976, // 1 cent = 0.0976 grounds
    Guntha: 0.0976, // 1 cent = 0.0976 gunthas
  },
  Guntha: {
    "Square Meter": 101.171, // 1 guntha = 101.171 square meters
    "Square Feet": 1089, // 1 guntha = 1089 square feet
    Hectare: 0.000101171, // 1 guntha = 0.000101171 hectares
    "Square Yard": 121, // 1 guntha = 121 square yards
    Acre: 0.000025, // 1 guntha = 0.000025 acres
    Bigha: 0.0031, // 1 guntha = 0.0031 bighas
    Ground: 0.0086, // 1 guntha = 0.0086 grounds
    Cent: 0.25, // 1 guntha = 0.25 cents
  },
};

function AreaCalculator() {
  const [inputValue, setInputValue] = useState(""); // User input value
  const [fromUnit, setFromUnit] = useState("Square Meter"); // Default from unit
  const [toUnit, setToUnit] = useState("Square Meter"); // Default to unit
  const [activeIndex, setActiveIndex] = useState(null); //Default to null as none of the faq is open
  const breadCrumbSchema = () => {
    return {
      __html: `{
        "@context": "https://schema.org/", 
        "@type": "BreadcrumbList", 
        "itemListElement": [{
          "@type": "ListItem", 
          "position": 1, 
          "name": "Home",
          "item": "https://www.orientbell.com"
        },{
        "@type": "ListItem", 
        "position": 2, 
        "name": "Area Conversion Calculator",
        "item": "https://www.orientbell.com/area-conversion-calculator"
      }]
      }`,
    };
  };

  const FaqSchema = () => {
    return {
      __html: `
     {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "url": "https://www.orientbell.com/area-conversion-calculator",
  "mainEntity": [{
    "@type": "Question",
    "name": "How does an area conversion calculator work?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "An area conversion calculator is a pretty straightforward tool that allows you to convert from one unit to another instantly. For example, using an area calculator, you can easily convert square feet into square metres or vice versa."
    }
  },{
    "@type": "Question",
    "acceptedAnswer": {
    "name": "How many dimensions are there in area calculation?",
    "acceptedAnswer": {
      "@type": "The area refers to the size of a two-dimensional figure, which is calculated by multiplying the length and breadth of a particular space."
    }
  },{
    "@type": "Question",
    "acceptedAnswer": {
    "name": "How to calculate the area of an irregular shaped piece of land?",
    "acceptedAnswer": {
      "@type": "Here are the steps to calculate the area of an irregularly shaped plot of land: 1. Divide the shape into smaller regular shapes, such as triangles, rectangles, and squares. 2. Measure the area of each small shape according to its relevant formula a. Rectangle – length x breadth b. Square – side x side or side2 c. Triangle – base x height ÷ 2 3. Add the areas of the individual shapes to get the total area of your irregular shaped piece of land."
    }
  },{
    "@type": "Question",
    "acceptedAnswer": {
    "name": "How do I convert square feet to acres?",
    "acceptedAnswer": {
      "@type": "1 Square Feet = 0.000023 Acre"
    }
  },{
    "@type": "Question",
    "acceptedAnswer": {
    "name": "What is the conversion factor between bigha and square metres?",
    "acceptedAnswer": {
      "@type": "1 Bigha = 1011.71367 Square Meter"
    }
  },{
    "@type": "Question",
    "acceptedAnswer": {
    "name": "How many square feet are there in one ground?",
    "acceptedAnswer": {
      "@type": "1 Ground = 2400.350017649 Square Feet"
    }
  },{
    "@type": "Question",
    "acceptedAnswer": {
    "name": "What is the formula to convert acres to hectares?",
    "acceptedAnswer": {
      "@type": "1 Acre = 0.404686 Hectare"
    }
  },{
    "@type": "Question",
    "acceptedAnswer": {
    "name": "How do I convert square metres to square yards?",
    "acceptedAnswer": {
      "@type": "1 Square Metre = 1.19599 Square Yards"
    }
  },{
    "@type": "Question",
    "acceptedAnswer": {
    "name": "What is the equivalent of square yards in square metres?",
    "acceptedAnswer": {
      "@type": "1 Square Yard = 0.836127 Square Metres"
    }
  },{
    "@type": "Question",
    "acceptedAnswer": {
    "name": "How do I convert hectares to bigha?",
    "acceptedAnswer": {
      "@type": "1 Hectare = 3.953686105 Bigha"
    }
  },{
    "@type": "Question",
    "acceptedAnswer": {
    "name": "What is the ratio between ground and square yards?",
    "acceptedAnswer": {
      "@type": "1 Ground = 266.71 Square Yards"
    }
  },{
    "@type": "Question",
    "acceptedAnswer": {
    "name": "How do I convert guntha to acres?",
    "acceptedAnswer": {
      "@type": "40 Gunthas = 1 Acre, So 1 Guntha = 0.025 Acres"
    }
  },{
    "@type": "Question",
    "acceptedAnswer": {
    "name": "What is the formula to convert acres to square feet?",
    "acceptedAnswer": {
      "@type": "1 Acre = 43,560 Square Feet"
    }
  }
  }]
}
      `,
    };
  };

  const faqData = [
    {
      question: "1. How does an area conversion calculator work?",
      answer:
        "An area conversion calculator is a pretty straightforward tool that allows you to convert from one unit to another instantly. For example, using an area calculator, you can easily convert square feet into square metres or vice versa.",
    },
    {
      question: "2. How many dimensions are there in area calculation?",
      answer:
        "The area refers to the size of a two-dimensional figure, which is calculated by multiplying the length and breadth of a particular space.",
    },
    // {
    //   question: "3. What is the formula to convert square feet to hectares?",
    //   answer: "1 Square Feet = 0.00000929 Hectare",
    // },
    // {
    //   question:
    //     "4. What is the conversion factor between square metres and bigha?",
    //   answer: "1 Square Meter = 0.000398663 Bigha",
    // },
    {
      question: "3. How is land area calculated?",
      answer:
        "Land area is calculated by measuring the length and width of the plot and multiplying them. Once you get the answer, you can convert it into  the desired unit like square feet or square meters.",
    },
    {
      question: "4. How to calculate land area in square feet",
      answer:
        " Multiply the length and width of the land (in feet) to get the area in square feet. For irregular plots, divide the land into smaller rectangles and add their areas.",
    },
    {
      question: "5. How do I convert square feet to acres?",
      answer: "1 Square Feet = 0.000023 Acre",
    },
    {
      question:
        "6. What is the conversion factor between bigha and square metres?",
      answer: "1 Bigha = 1011.71367 Square Meter",
    },
    {
      question: "7. How many square feet are there in one ground?",
      answer: "1 Ground = 2400.350017649 Square Feet",
    },
    {
      question: "8. What is the formula to convert acres to hectares?",
      answer: "1 Acre = 0.404686 Hectare",
    },
    {
      question: "9. How do I convert square metres to square yards?",
      answer: "1 Square Metre = 1.19599 Square Yards",
    },
    // {
    //   question: '11. What is the conversion ratio between guntha and square feet?',
    //   answer: '1 Guntha = 1088.999963702 Square Feet',
    // },
    // {
    //   question: '12. How can I convert katha to square metres?',
    //   answer: '1 Katha = 126.44 Square Metres',
    // },
    {
      question: "10. What is the equivalent of square yards in square metres?",
      answer: "1 Square Yard = 0.836127 Square Metres",
    },
    {
      question: "11. How do I convert hectares to bigha?",
      answer: "1 Hectare = 3.953686105 Bigha",
    },
    // {
    //   question: '15. What is the conversion factor between cents and square feet?',
    //   answer: '1 Cent = 435.6 Square Feet',
    // },
    // {
    //   question: "16. How many acres are there in one bigha?",
    //   answer: "1 Bigha = 0.619 acres",
    // },
    {
      question: "12. What is the ratio between ground and square yards?",
      answer: "1 Ground = 266.71 Square Yards",
    },
    {
      question: "13. How do I convert guntha to acres?",
      answer: "40 Gunthas = 1 Acre, So 1 Guntha = 0.025 Acres",
    },
    {
      question: "14. What is the formula to convert acres to square feet?",
      answer: "1 Acre = 43,560 Square Feet",
    },
    // {
    //   question: "20. What is the ratio between guntha and square metres?",
    //   answer: "1 Guntha = 101.17 Square Metres",
    // },
    // {
    //   question: "21. How do I convert square feet to cents?",
    //   answer: "1 Square Feet = 0.002296169 Cent",
    // },
  ];

  //Toggle FAQs
  const toggleFaq = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  // Update conversion result whenever units or input value change
  let convertedArea = inputValue;
  if (fromUnit !== toUnit) {
    convertedArea = (
      parseFloat(inputValue) * areaConversionFactors[fromUnit][toUnit]
    ).toFixed(5);
  }

  // Generate options for the dropdowns
  const unitOptions = Object.keys(areaConversionFactors);

  // Function to handle swapping the "From" and "To" units
  const handleSwapUnits = () => {
    // Swapping the fromUnit and toUnit
    let temp = toUnit;
    setToUnit(fromUnit);
    setFromUnit(temp);
  };

  return (
    <>
      <Head>
        <title>Area Conversion Calculator in India | Orientbell Tiles</title>
        <meta
          name="title"
          content="Area Conversion Calculator in India | Orientbell Tiles"
        />
        <meta
          name="description"
          content="Area Converter is a versatile tool for measuring and converting plot and agricultural land areas. It swiftly converts between various units such as hectares, acres, square feet, square meters, and more."
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={breadCrumbSchema()}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={FaqSchema()}
        />
      </Head>
      <div className="areaCalc-cnvrtrSec-section">
        <div className="container">
          <Breadcrumb>
            <BreadcrumbItem href="https://www.orientbell.com/">
              Home
            </BreadcrumbItem>
            <BreadcrumbItem href="#">Area Conversion Calculator</BreadcrumbItem>
          </Breadcrumb>
          <div class="areacalculator-content">
            <h1>Area Conversion Calculator</h1>
            <p>
              Area is measured in a variety of units. You have your usual and
              commonly used square feet, square metres, acres, hectares, etc.,
              but you also have regional units, such as guntha, bigha, cent,
              ground, etc. This makes it very difficult to figure out the area
              of any space. An area conversion calculator is a tool that helps
              you convert the measurement of an area between the various units.
            </p>

            <p>
              We can keep the calculator like the below screenshot. This sample
              screenshot is from Magic Bricks.
            </p>

            <p>
              Consider making from the similar one as this one is most
              appropriate as compared to other calculators found online -
            </p>
          </div>
          <div class="areaCalc-cnvrtrSec-row">
            <h2>Area Conversion</h2>
            <div class="areaCalc-data">
              <div class="areaCalc">
                <label>Enter No. of Units</label>
                <input
                  type="number"
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  placeholder="Enter value"
                />
              </div>
              <div class="areaCalc__cnvrtrSec__inputWrapper">
                <div class="areaCalc">
                  <label>From</label>
                  <select
                    class="stateSearchInputId"
                    value={fromUnit}
                    onChange={(e) => setFromUnit(e.target.value)}
                  >
                    {unitOptions.map((unit) => (
                      <option key={unit}>{unit}</option>
                    ))}
                  </select>
                </div>
                <div class="unitsuffel-btn" onClick={handleSwapUnits}>
                  <img
                    src="red-bidirectional-arrow-svg.png"
                    alt="red bidirectional arrow"
                  />
                </div>
                <div class="areaCalc">
                  <label>To</label>
                  <select
                    class="stateSearchInputId"
                    value={toUnit}
                    onChange={(e) => setToUnit(e.target.value)}
                  >
                    {unitOptions.map((unit) => (
                      <option key={unit}>{unit}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            {inputValue && (
              <div className="result">
                {inputValue} {fromUnit} is equal to {convertedArea} {toUnit}
              </div>
            )}
          </div>

          <div class="areacalculator-content">
            <h2>Most Searched Conversion Units for Area Calculator in India</h2>
            <ol>
              <li>
                <h5>Square Feet (sq ft)</h5>
                <p>
                  Square feet is a unit of measurement used to denote the area
                  of a space in feet. This is a standard unit of measurement for
                  land used across the globe in countries like the USA, Canada,
                  UK, India, Pakistan, Bangladesh, Nepal, Singapore, Malaysia,
                  and Ghana. Square Feet is often denoted by sq. ft. or ft2.
                </p>
              </li>
              <li>
                <h5>Square Meter (sq m)</h5>
                <p>
                  Square metre is another unit of measurement, primarily used to
                  measure the two-dimensional area of spaces such as land,
                  floor, walls, etc. It is also widely considered to be a
                  standard unit of measurement across the world. Square Metre is
                  typically denoted by sq. m. or m2.
                </p>
              </li>
              <li>
                <h5>Square Yard (sq yd)</h5>
                <p>
                  The square yard is an imperial unit unlike the previous two
                  that are metric, and is very commonly used across primarily
                  English-speaking nations such as the USA, Canada, UK, India,
                  and Pakistan. In India, the unit is frequently referred to as
                  gaj or gaz. Square Yard is typically denoted by sq. yd. or
                  yd2.
                </p>
              </li>
              <li>
                <h5>Acre (ac)</h5>
                <p>
                  The acre is one of the oldest units used to measure land.
                  Originally it was only used in the imperial system, but now it
                  is used across the globe. An acre can be considered to be an
                  area that is 4 rods wide by one long furlong. This unit can be
                  used to measure all kinds of shapes such as rectangles,
                  squares, pentagons, and even circles. As long as the total
                  area of the land does not exceed 43,560 square feet it can be
                  considered to be an acre, regardless of its length or width.
                  An Acre is denoted by ac.
                </p>
              </li>
              <li>
                <h5>Hectare (ha)</h5>
                <p>
                  Hectare is another commonly used unit of measurement across
                  the world, and it is a metric unit. Countries like the US, UK,
                  India, Myanmar, Australia, EU, and Canada are where hectare is
                  used commonly. Hectare is commonly denoted as ha. It also has
                  various names around the world, such as:
                </p>
                <ol>
                  <li>
                    <p>Jerib in Iran</p>
                  </li>
                  <li>
                    <p>Gong Qing in China</p>
                  </li>
                  <li>
                    <p>Bunder in Netherlands</p>
                  </li>
                  <li>
                    <p>Manzana in Argentina</p>
                  </li>
                </ol>
              </li>
              <li>
                <h5>Bigha</h5>
                <p>
                  Bigha is a traditional unit of measurement commonly used in
                  the Northern (and some Western and Eastern) States of India,
                  such as Rajasthan, Punjab, Haryana, Uttar Pradesh, Assam,
                  Gujarat, West Bengal, Bihar, Jharkhand, Himachal Pradesh, and
                  Uttarakhand. While the name of the unit is the same, the
                  measurement of the unit varies from state to state. The term
                  “kuchha bigha” is often used by landlords, while the term
                  “Pucca” or “pakka bigha” is often used in parts of Uttar
                  Pradesh, Uttarakhand, Bihar, and Rajasthan.
                </p>
              </li>
              <li>
                <h5>Ground</h5>
                <p>
                  The unit of measurement “Ground” is used in India and measures
                  approximately 2,190 sq. ft. or about 203 sq. m. While it was
                  phased out around the mid 20th century with the adoption of
                  the metric system, the unit of measurement is still popular in
                  the real estate sector.
                </p>
              </li>
              <li>
                <h5>Cent</h5>
                <p>
                  Used typically in parts of South India, the cent is a unit of
                  measuring area. Apart from the usual metric units, states like
                  Andhra Pradesh, Kerala, Telangana, Karnataka, and Tamil Nadu
                  use the cent. A cent is an area that measures about 1/100th of
                  an acre, which works out to about 435 sq. ft. or about 40.5
                  sq. m. The unit is often used in the real estate sector and
                  while in news reporting.
                </p>
              </li>
              <li>
                <h5>Guntha</h5>
                <p>
                  The guntha or gunta is a unit of measurement of area used in
                  South Asian countries, especially India. It measures about
                  1,089 sq. ft. or 101.17 sq. m.
                </p>
                <p>
                  There you have it; some of the most commonly used units of
                  land measurement in India. These units are used for a variety
                  of sectors dealing primarily with land, such as construction,
                  real estate, and agriculture.
                </p>
              </li>
            </ol>

            <h2>What are different land measurement units?</h2>
            <p>
              Each area of India uses a region specific unit of measurement,
              apart from the standard units.
            </p>

            <h4>Units for measurement of land used in North India</h4>
            <p>
              There are some of the most common units of land measurement used
              in the north Indian states, such as Haryana, Uttarakhand, Punjab,
              Uttar Pradesh, etc. These include Bigha, Biswa, Biswansi, Ghumaon,
              Kanal and Killa
            </p>

            <h4>Units for measurement of land used in South India</h4>
            <p>
              Some of the most common units of land measurement used in the
              south Indian states, such as Karnataka, Kerala, Andhra Pradesh,
              Telangana, Tamil Nadu are: Ankanam, Cent, Ground, Guntha, Kuncham
            </p>

            <h4>Units for measurement of land used in East India</h4>
            <p>
              Here are some of the most common units of land measurement used in
              the east Indian states, such West Bengal, Tripura, Jharkhand,
              Bihar, Assam, etc: Chatak, Decimal, Dhur, Kattha, Lecha.
            </p>

            <h4>Units for measurement of land used in East India</h4>
            <p>
              Here are some of the most common units of land measurement used in
              the east Indian states, such Gujarat and Rajasthan: Bigha, Biswa,
              Biswansi
            </p>

            <h2>How to Use an Area Conversion Calculator Effectively?</h2>
            <p>
              An area conversion calculator utilises standard formulas to
              instantly convert land area across various units, such as square
              feet to square meters or acres to hectares.
            </p>
            <ul>
              <li> Step 1:</li>
              <p>Enter the area value you want to convert.</p>
              <li> Step 2:</li>
              <p>
                Select the current unit and the unit you wish to convert to.
                With just one click, the result appears instantly.
              </p>
            </ul>
            <p>
              Whether you’re checking plot sizes or comparing land rates, this
              simple tool can save time and confusion. For quick and reliable
              conversions, the area converter is your go-to solution.
            </p>

            <h2>
              Online Land Area Calculator: Measure Any Plot Size Instantly
            </h2>
            <p>
              An online land area calculator makes it easy to measure and
              convert plot sizes in just a few seconds.
            </p>
            <p>
              Enter the value and choose the unit of measurement—square feet,
              square yards, acres, or local units like Bigha or Guntha. The
              calculator displays the equivalent area immediately in your
              selected unit. It's perfect for anyone who works with buying,
              selling, or valuing land—especially if units vary from location.
            </p>
            <p>
              Forget about manual calculation or guesswork with this calculator.
              Whether you are a homeowner doing some renovation or a contractor
              assessing project land, this land area calculator online makes
              your work simpler with accurate real-time conversions.
            </p>

            <h2>What is an area conversion table?</h2>
            <p>
              An <strong> Area conversion table </strong> shows how different
              land measurement units relate to one another. It helps users
              convert between units, such as square feet, square meters, acres,
              hectares, bigha, and guntha, without requiring any calculations.
              <br />
              Here's a quick look:
            </p>
            <div className="calculatortable-row">
              <table className="calculator-data-table-bx" border="0">
                <thead>
                  <tr>
                    <th>Unit</th>
                    <th>1 Square Meter Equals</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Sq. Feet</td>
                    <td>10.7639 sq ft</td>
                  </tr>
                  <tr>
                    <td>Sq. Yard</td>
                    <td>1.19599 sq yd</td>
                  </tr>
                  <tr>
                    <td>Acre</td>
                    <td>0.0002471 acres</td>
                  </tr>
                  <tr>
                    <td>Hectare</td>
                    <td>0.0001 hectares</td>
                  </tr>
                  <tr>
                    <td>Guntha</td>
                    <td>0.0025 gunthas</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <br />
            <p>
              This <strong> Area conversion table </strong> is a quick tool for
              real estate professionals, architects, and homeowners alike. To
              get a more accurate result, try it with the area conversion
              calculator.{" "}
            </p>
          </div>

          <div class="areacalculator-faq">
            <h2>Frequently Asked Questions about Area Conversion:</h2>
            <div className="newacd">
              <Faqs Fullfaqs={faqData} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AreaCalculator;
